
















import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import EntryLayout from '@/components/entry/Layout.vue'

@Component({
  components: {
    EntryLayout
  }
})
export default class UserEmailConfirmation extends VueBase {
  showRecruit(): void {
    window.open(this.settings.site.recruit, '_blank')
    window.location.href = '/mypage'
  }

  showTop(): void {
    window.open(this.settings.site.top, '_blank')
    window.location.href = '/mypage'
  }
}
